import { API_BASE_URL } from '../config/api';

export const deleteImage = (image, token) => {
  fetch(`${API_BASE_URL}/api/products/image`, {
    method: "DELETE",
    body: JSON.stringify({ image }),
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  });
};
